import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import "../App.css";
import {useNavigate, useSearchParams} from "react-router-dom";
import PropertySelection from "../components/property_selection";

import ApiClient from "../sdk/ApiClient";
import {useKeycloak} from "@react-keycloak/web";

const Property = () => {

    const {keycloak} = useKeycloak();
    const navigate = useNavigate();

    const [queryParameters] = useSearchParams()

    const [mission, setMission] = useState(null);
    const [members, setMembers] = useState({});
    const [isSendDisabled, setIsSendDisabled] = useState(false);

    const apiClientInstance = useMemo(() => new ApiClient(keycloak.token), [keycloak.token]);

    useEffect(() => {
        setIsSendDisabled(false)
    }, []);

    useEffect(() => {

        // Méthode pour récupérer les missions
        const fetchMissionById = async (missionId) => {
            try {
                const data = await apiClientInstance.getMissionById(missionId)
                setMission(data);
            } catch (error) {
                console.error("Erreur lors de la récupération des missions :", error);
            }
        };

        fetchMissionById(queryParameters.get("missionId"));

    }, [queryParameters, apiClientInstance]);

    const OnClickNext = async () => {
        var membersId = members.map(x => x.id);
        let campaign = {
            mission: mission,
            membersId: membersId,
        }
        navigate(`/send?from=property`, {state : campaign});
    }

    const onClickBack = () => {
        navigate(`/missions`);
    }

    const onSelectedMembersChanged = useCallback(( selectedMembers) => {
        setMembers(selectedMembers);
        var disabled = selectedMembers.length === 0;
        setIsSendDisabled(disabled)
    },[])

    if (mission == null) {
        return <div>Chargement...</div>;
    }

    return (
        <Box sx={{display: "flex", flexDirection: "column", height: "100vh", padding:5}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <Button name={"back"} variant="outlined" onClick={onClickBack}>PRECEDENT</Button>
                <Typography variant="h4">{mission.label}</Typography>
                <Button name={"next"} variant="outlined" onClick={OnClickNext}
                        disabled={isSendDisabled}>Suivant</Button>
            </Box>
            {/* Contenu principal */}
            <Box component="main" sx={{flexGrow: 1, paddingTop:3, height: "70vh"}}>
                <PropertySelection onSelectedMembersChanged={onSelectedMembersChanged}></PropertySelection>
            </Box>
        </Box>
    );
}

export default Property;
